export const getMatchingName = ({
  groupNames,
  productName,
}: {
  groupNames?: string[]
  productName: string
}) => {
  let matchingName: string | null = null

  groupNames?.forEach(groupNamesItem => {
    // Grouping is case-insensitive
    const standardizedProductName = productName.toLowerCase()
    const standardizedGroupNamesItem = groupNamesItem.toLowerCase()

    if (standardizedProductName.includes(standardizedGroupNamesItem) && !matchingName) {
      matchingName = groupNamesItem
    }
  })

  return matchingName
}
